import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const TYPE_MAP = {
  growth_video: { label: '成长视频', color: '#666' },
  painting_animation: { label: '画作动画', color: '#666' },
  ai_animation: { label: 'AI动画', color: '#666' },
  photo: { label: '照片', color: '#666' },
  ugc_video: { label: 'UGC视频', color: '#666' }
}

function formatSize(bytes) {
  if (!bytes) return '0 B'
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
}

export default function MediaLibrary() {
  const [assets, setAssets] = useState([])
  const [stats, setStats] = useState({ total: 0, growth_videos: 0, painting_animations: 0, ai_animations: 0, photos: 0, ugc_videos: 0 })
  const [loading, setLoading] = useState(true)
  const [typeFilter, setTypeFilter] = useState('')
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const pageSize = 20

  useEffect(() => {
    loadAssets()
  }, [typeFilter, page])

  const loadAssets = () => {
    setLoading(true)
    const params = new URLSearchParams({ pageSize: String(pageSize), page: String(page) })
    if (typeFilter) params.set('type', typeFilter)
    fetch(`${API}/child-assets?${params}`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setAssets(d.data || [])
          setStats(d.stats || {})
          setTotal(d.pagination?.total || 0)
        }
      })
      .catch(() => setAssets([]))
      .finally(() => setLoading(false))
  }

  const filteredAssets = assets.filter(a => {
    if (!search) return true
    const q = search.toLowerCase()
    return (a.title || '').toLowerCase().includes(q) || (a.child_name || '').toLowerCase().includes(q)
  })

  const totalPages = Math.ceil(total / pageSize)

  return (
    <div style={{ padding: '0 24px 24px' }}>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎬 媒体?</h2>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 24 }}>
        {[
          { label: '全部资产', value: stats.total || 0, color: '#666' },
          { label: '成长视频', value: stats.growth_videos || 0, color: '#666' },
          { label: '画作动画', value: stats.painting_animations || 0, color: '#666' },
          { label: 'AI动画', value: stats.ai_animations || 0, color: '#666' },
          { label: '照片', value: stats.photos || 0, color: '#666' },
          { label: 'UGC视频', value: stats.ugc_videos || 0, color: '#666' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* 筛选栏 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
        <input
          style={{ flex: 1, padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}
          placeholder="搜索标题或孩子姓?.."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select value={typeFilter} onChange={e => { setTypeFilter(e.target.value); setPage(1) }}
          style={{ padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}>
          <option value="">全部类型</option>
          {Object.entries(TYPE_MAP).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
        <button onClick={loadAssets} style={{ padding: '8px 16px', background: '#fff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
          🔄 刷新
        </button>
      </div>

      {/* 资产列表 */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              {['标题', '孩子', '类型', '文件大小', '创建时间', '操作'].map(h => (
                <th key={h} style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{ padding: 40, textAlign: 'center', color: '#666' }}>加载中...</td></tr>
            ) : filteredAssets.length === 0 ? (
              <tr><td colSpan={6} style={{ padding: 40, textAlign: 'center', color: '#666' }}>暂无资产</td></tr>
            ) : filteredAssets.map(a => {
              const t = TYPE_MAP[a.asset_type] || { label: a.asset_type, color: '#999' }
              return (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: 12, fontSize: 13, maxWidth: 200 }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={a.title}>{a.title || '无标'}</div>
                  </td>
                  <td style={{ padding: 12, fontSize: 13, color: '#666' }}>{a.child_name || '未知'}</td>
                  <td style={{ padding: 12 }}>
                    <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: t.color + '22', color: t.color }}>
                      {t.label}
                    </span>
                  </td>
                  <td style={{ padding: 12, fontSize: 13, color: '#666' }}>{formatSize(a.file_size)}</td>
                  <td style={{ padding: 12, fontSize: 13, color: '#666' }}>{a.created_at ? a.created_at.substring(0, 16) : ''}</td>
                  <td style={{ padding: 12 }}>
                    <button
                      style={{ padding: '4px 10px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, background: '#fff', color: '#fff' }}
                      onClick={() => a.content_url && window.open(a.content_url, '_blank')}
                    >
                      查看
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>

        {/* 分页 */}
        {totalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, padding: '16px 0' }}>
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
              style={{ padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: page === 1 ? 'not-allowed' : 'pointer' }}>
              上一</button>
            <span style={{ fontSize: 13, color: '#666' }}>?{page} / {totalPages} 页，?{total} ?</span>
            <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
              style={{ padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff', cursor: page === totalPages ? 'not-allowed' : 'pointer' }}>
              下一</button>
          </div>
        )}
      </div>
    </div>
  )
}
